import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_148: DocMigration = {
  maxSchemaVersion: "0.0.148",
  description: "Turn levels into a table",
  apply(json: any) {
    if (!json.levels) {
      json.levels = {};
      const level = {
        entityType: "LEVEL",
        id: uid(),
        name: "Level 1",
        sortIndex: 0,
        topOfWall: 108,
      };

      json.levels[level.id] = level;
    } else {
      // Strangely, I've run into this issue. Glad to be getting rid of it.
      const levels = Array.isArray(json.levels) ? json.levels : Object.values(json.levels);

      const tableIndexToUid = levels.map((x) => {
        if (!(x.uniqueId)) {
          console.assert(false, "no uniqueId on level");
        }
        return x.uniqueId;
      });

      // convert level to table and DocEntityBase
      const oldLevelsArray = levels;
      json.levels = {};

      for (let i = 0; i < oldLevelsArray.length; i++) {
        const level = oldLevelsArray[i];
        json.levels[level.uniqueId] = level;

        level.entityType = "LEVEL";
        level.id = level.uniqueId;
        delete level.uniqueId;
      }

      // blocks
      for (const blockId in json.blocks) {
        const block = json.blocks[blockId];
        block.levelId = tableIndexToUid[block.levelId];
      }

      // virtual block roofs
      for (const roofId in json.roofs) {
        const roof = json.roofs[roofId];
        const { blocks } = roof;

        if (typeof blocks === "object" && blocks.type === "VIRTUAL_ROOF_BLOCK") {
          blocks.levelId = tableIndexToUid[blocks.levelId];
        }
      }

      // stair systems
      for (const stairSystemId in json.stairSystems) {
        const stairSystem = json.stairSystems[stairSystemId];
        stairSystem.levelId = tableIndexToUid[stairSystem.levelId];
      }

      // railings
      for (const railingId in json.railings) {
        const railing = json.railings[railingId];
        railing.levelId = tableIndexToUid[railing.levelId];
      }

      // foundations
      for (const foundationId in json.foundations) {
        const foundation = json.foundations[foundationId];
        if (foundation.perimeter && foundation.perimeter.type === "LEVEL") {
          foundation.perimeter.levelId = tableIndexToUid[foundation.levelId];
        }
      }

      for (const entityHash in json.hidden) {
        const handle = json.hidden[entityHash];

        if (handle.type === "LEVEL") {
          delete json.hidden[entityHash];
          json.hidden[`level.${tableIndexToUid[handle.levelId]}`] = {
            type: "LEVEL",
            levelId: tableIndexToUid[handle.levelId],
          };
        }
      }

      for (const entityHash in json.locked) {
        const handle = json.locked[entityHash];

        if (handle.type === "LEVEL") {
          delete json.locked[entityHash];
          json.locked[`level.${tableIndexToUid[handle.levelId]}`] = {
            type: "LEVEL",
            levelId: tableIndexToUid[handle.levelId],
          };
        }
      }
    }

    return json;
  },
};

export default migration_0_0_148;
